/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React, { useCallback, useContext, useEffect, useState } from "react"
import TopHeader from "../../components/TopHeader"
import CustomOverLay from "../../components/CustomOverLay"
import ManageDeviceTable from "../ManageDevice/Components/Table"
import Limit from "../../components/Limit"
import Pagination from "../../components/Pagination"
import SearchEmptyScreen from "../../components/SearchEmptyScreen"
import Emptyscreen from "../../components/EmptyScreen"
import GlobalContext from "../../components/Context/GloablContext"
import { useLocation, useSearchParams } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { resetArrays } from "../../redux/MultiselectRowsConditionally"
import Debounce from "../../CommonMethods/Debounce"
import ManageDashboardTopBar from "./Component/Topbar"
import ManageDashboardTable from "./Component/Table"
import moment from "moment"
import { handleAddFilterValues } from "../../redux/systemConfigSlice"
import { convertDatesToEpochUTC } from "../../CommonMethods/ConvertFilterDatetoEpochUtcFormat"
import { useGetAlertListQuery } from "../../features/dashBoardSlice"
import EnsureProperEncoding from "../../CommonMethods/EnsureProperEncoding"
import DashboardAdvancedSearchbar from "./Component/AdvancedSearch"
import { setDashboardSearchApplied } from "../../redux/dashboardSearchSlice"

export default function AlertListOfPatients(){
    const { isSideBar,isAdvancedSearchOpen } = useContext(GlobalContext);
    const [suggestions, setSuggestions] = useState("")
    const [limit, setLimit] = useState("15")
    const [skip, setSkip] = useState(true)
    const [selectedRow, setSelectedRow] = useState()
    const [isColumnSelect, setIsColumnSelect] = useState(false)
    const location = useLocation()
    const dispatch = useDispatch()
    const [searchParams, setSearchParams] = useSearchParams();
    const [loading, setLoading] = useState(false)
    const auth = useSelector(state => state?.auth)
    const { userType } = auth
    const [isSortselected,setisSortSelected]=useState(false)
    const dashboardSearch = useSelector(state => state.DashboardSearchData);

    const initialState = {
        "reading_type": [],
        "alert_type": [],
    };
    
    const [filterValues, setFilterValues] = useState(initialState);

    const [dateFilter,setdateFilter]=useState({
        "filter_start_date": searchParams?.get('start_date')
            ? new Date(searchParams.get('start_date')).toISOString().split('T')[0] // Parse formatted date string
            : (() => {
                const today = new Date();
                today.setDate(today.getDate() - 1); // Subtract 1 day for start date
                return today.toISOString().split('T')[0];
            })(), // Default to yesterday's date
        "filter_end_date": searchParams?.get('end_date')
            ? new Date(searchParams.get('end_date')).toISOString().split('T')[0] // Parse formatted date string
            : (() => {
                const today = new Date();
                today.setDate(today.getDate() + 1); // Add 1 day for end date
                return today.toISOString().split('T')[0];
            })(), // Default to tomorrow's date
    })
  
    let queryParamsPassed={searchparams:searchParams?.toString()}
    const { data, isFetching, isLoading, status } = useGetAlertListQuery(queryParamsPassed, { skip: skip || location.search === '' })

    /**
     * The function `handleSearchParams` updates the search parameters by setting the value of a
     * specific key and value, and then updating the search parameters state.
     */
    const handleSearchParams = (key, value) => {
        let params = Object.fromEntries(searchParams);
        params.page_number = 1
        params.last_page = null
        params.last_id = null
        params.last_sort_value=null
        if (key === 'search_value') { params[key] = encodeURIComponent(value); }
        else params[key] = value
        if (params.search_value === '') delete params.search_value
        setSearchParams({ ...params })
    }

    const handleDispatch = useCallback(()=>{
               
        if (location.search_value === '') {
            setSkip(true)
        }
        if (location.state !== null && location.state !== '' && !Array.isArray(location.state)) {
            let params = {};
            if (location?.state?.search_value !== '') {
                params = {
                    'limit': location.state.limit,
                    'page_number': location.state.page_number,
                    'search_value': decodeURIComponent(location.state.search_value),
                    'last_id':null,
                    'last_page':null,
                    'last_sort_value':null
                }
            } else {
                params = {
                    'limit': location.state.limit,
                    'page_number': location.state.page_number,
                    'last_id':null,
                    'last_page':null,
                    'last_sort_value':null
                }

            }
            setSearchParams({ ...params })
        }
        else {
            if (!searchParams.get('limit')) {
                handleSearchParams('limit', '15')
            }
            if (!searchParams.get('page_number')) {
                handleSearchParams('page_number', '1')
            }
            if (!searchParams.get('last_id')) {
                data===undefined?handleSearchParams('last_id', null):handleSearchParams('last_id', data?.data?.[data?.data?.length-1]?._id);
            }
            if (!searchParams.get('last_page')) {
                handleSearchParams('last_page', null)
            }
            if (!searchParams.get('last_sort_value')) {
                handleSearchParams('last_sort_value', null)
            }
            if(!searchParams.get('start_date')) { 
                handleSearchParams('start_date', moment(dateFilter?.filter_start_date).format('YYYY-MM-DD'))
            }
            if(!searchParams.get('end_date')) { 
                handleSearchParams('end_date', moment(dateFilter?.filter_end_date).format('YYYY-MM-DD'))
            }
            if (!searchParams.get('filter')) {
                handleSearchParams('filter', true)
            }
         
        }
        setSuggestions(!searchParams.get('search_value') ? '' : decodeURIComponent(searchParams.get('search_value'))|| '')

    },[location])
    
    useEffect(() => {
        handleDispatch()
        
    }, [handleDispatch]);

    useEffect(() => {
        if (searchParams.size >= 5) {
            setSkip(false)
        }
        else {
            setSkip(true)
        }
    }, [searchParams])

    useEffect(()=>{
        return(()=>{
            dispatch(resetArrays())
        })
    },[])

    function handleNoOfRowsClick(number) {
        // setLoading(true);
        let params = Object.fromEntries(searchParams);
        params.page_number = 1;
        params["limit"] = number;
        params['last_id']=null
        params['last_page'] =null
        params['last_sort_value']=null
        setSearchParams({ ...params });
    }
    const handleOnClickPageNumber = (pageNum) => {
        setisSortSelected(false)
        
        const params = Object.fromEntries(searchParams)
        let keysort= decodeURIComponent(searchParams.get('sort')?.split('+')[0])
        searchParams?.get('sort')!==null?params.last_sort_value =EnsureProperEncoding(pageNum===1?null:(searchParams?.get('page_number')>pageNum?(data?.data?.[0]?.[keysort]!==undefined?data?.data?.[0]?.[keysort]:null):(data?.data?.[data?.data?.length-1]?.[keysort]!==undefined?data?.data?.[data?.data?.length-1]?.[keysort]:null))):''
       
        const lastId = pageNum === 1 ? null :
            (searchParams?.get('page_number') > pageNum ?
                (data?.data?.[0]?._id !== undefined ? data?.data[0]?._id : null) :
                (data?.data?.[data?.data?.length - 1]?._id !== undefined ? data?.data[data?.data?.length - 1]?._id : null));
      
        const lastPage = pageNum === 1 ? null :
            (searchParams?.get('page_number') > pageNum ? searchParams?.get('page_number') : searchParams?.get('page_number'));
        setSearchParams({ ...params, page_number: pageNum, last_id: lastId, last_page: lastPage });
        // dispatch(addToTopCheckbox([pageNum.selected+1,searchParams.get("limit")]))
    }

    const handleChange = (val) => {
        handleSearchParams('search_value', val)
    };

    const optimizedFn = useCallback(
        Debounce((value) => handleChange(value)),
        [searchParams]
    );

    const handleApplyFilter = (type) => {
        let params = { ...Object.fromEntries(searchParams) };

        const filterValuesToDispatch = {};
    
        if (filterValues.search_value) {
            filterValuesToDispatch['search_value'] = filterValues.search_value;
        }
    
        if (Array.isArray(filterValues.reading_type) && filterValues.reading_type.length > 0) {
            filterValuesToDispatch["reading_type"] = filterValues.reading_type.join(',');
        }
        if (Array.isArray(filterValues.alert_type) && filterValues.alert_type.length > 0) {
            filterValuesToDispatch["alert_type"] = filterValues.alert_type.join(', ');
        } else if (filterValues.alert_type !== "") {
            filterValuesToDispatch["alert_type"] = filterValues.alert_type;
        }
    
        if (type) {
            const updatedParams = {
                filter: "true",
                page_number: 1,
                last_id:null,
                last_page:null,
                last_sort_value:null,
                limit,
               
                ...(Array.isArray(filterValues.reading_type) && filterValues.reading_type.length > 0 && { reading_type: filterValues.reading_type.join(',') 
                }),
                // ...(filterValues.alert_type.length > 0 && { alert_type: filterValues.alert_type.join(', ') }),

                ...(Array.isArray(filterValues.alert_type) && filterValues.alert_type.length > 0 && { 
                    alert_type: filterValues.alert_type.join(',') ,
                }),
                
            };
            if (searchParams.get('search_value')) {
                updatedParams.search_value = searchParams.get('search_value');
            }
            setSearchParams(updatedParams);
    
        } else {
            delete params['reading_type'];
            // delete params['alert_type'];
            // delete params['start_date'];
            delete params['end_date'];
            setSearchParams(params);
        }
    
        dispatch(handleAddFilterValues(filterValuesToDispatch));
    };
    
    function handleCheckBox(key, option) {
        setIsAnyFieldFilled!==undefined&&setIsAnyFieldFilled(true)
        setFilterValues((prev) => {
            const updatedFilterValues = { ...prev };
            // If the key already exists, toggle the option in the array
            updatedFilterValues[key] = updatedFilterValues[key] ? (
                updatedFilterValues[key].includes(option)
                    ? updatedFilterValues[key].filter(item => item !== option)
                    : [...updatedFilterValues[key], option]
            ) : [option];
            return updatedFilterValues;
        });
    } 

    const handleClearFilter = () => {
        let params = Object.fromEntries(searchParams);
        delete params.reading_type
        delete params.alert_type
        delete params.end_date
        delete params.start_date
        delete params.filter
        setSearchParams({ ...params })
    }

    // apply search function (I need this code for final confrimation)
    const handleOnSubmit = (e) => {
        e.preventDefault();
        
        let searchString = '';
            
        // Utility function to handle __NULL__ logic for search values
        const formatSearchValue = (value) => {
            const trimmedValue = value.trim();
            return trimmedValue === '-' ? '__NULL__' : trimmedValue;
        };
    
        // Check for `patient_id` and `patient_id_inverse` conditions
        if (dashboardSearch?.patient_id && dashboardSearch.patient_id.trim() !== '') {
            const patientIdPrefix = dashboardSearch.patient_id_inverse ? 'ne:' : '';
            const formattedPatientId = formatSearchValue(dashboardSearch?.patient_id);
            searchString += `patient_id=${patientIdPrefix}${encodeURIComponent(formattedPatientId)};`;
        }
    
        // Check for `device_id` and `device_id_inverse` conditions
        if (dashboardSearch?.device_id && dashboardSearch.device_id.trim() !== '') {
            const device_idPrefix = dashboardSearch.device_id_inverse ? 'ne:' : '';
            const formatteddevice_id = formatSearchValue(dashboardSearch?.device_id);
            searchString += `device_id=${device_idPrefix}${encodeURIComponent(formatteddevice_id)};`;
        }
    
        // check for reading_details field
        if (dashboardSearch?.reading_details) {
            const readingDetailsPrefix = dashboardSearch.reading_details_inverse ? 'ne:' : '';
            const formattedReadingDetails = `*${formatSearchValue(dashboardSearch?.reading_details)}*`;
            searchString += `reading_details=${readingDetailsPrefix}${encodeURIComponent(formattedReadingDetails)};`;
        }
    
        // Check for `patient_name` and `patient_name_inverse` conditions
        if (dashboardSearch?.patient_name && dashboardSearch.patient_name.trim() !== '') {
            const alertDescriptionPrefix = dashboardSearch.patient_name_inverse ? 'ne:' : '';
            const formattedAlertDescription = formatSearchValue(dashboardSearch?.patient_name);
            searchString += `full_name=${alertDescriptionPrefix}${encodeURIComponent(formattedAlertDescription)};`;
        }

        // Check for `user_name` and `user_name_inverse` conditions
        if (dashboardSearch?.user_name || dashboardSearch.user_name_domain) {
            const userNamePrefix = dashboardSearch.user_name_inverse ? 'ne:' : '';
            const userName = formatSearchValue(dashboardSearch.user_name || '');
            const userNameDomain = formatSearchValue(dashboardSearch.user_name_domain || '');
            searchString += `user_name=${userNamePrefix}${encodeURIComponent(userName)}@${encodeURIComponent(userNameDomain)};`;
        }
    
        // Remove trailing ';' if present
        searchString = searchString.endsWith(';') ? searchString.slice(0, -1) : searchString;
            
        // Merge all search parameters into a single object
        const currentParams = Object.fromEntries(searchParams); // Get existing params
        const newParams = {
            ...currentParams, // Preserve existing params (limit, sort, etc.)
            search_value: searchString || '', // Add search string
            search_mode: (dashboardSearch.match === false || dashboardSearch.match==='' )? 'and' : 'or', // Add search mode
            page_number: 1, // Reset page number on new search
            last_id: null, // Reset last_id on new search
            last_page: null, // Reset last_page on new null
            last_sort_value :null , // Reset last_sort_value on new search
            limit: currentParams.limit || '15', // Keep limit or set default
        };
        
        // Remove empty search key if search string is empty
        if (!newParams.search_value) delete newParams.search_value;

        // Update all searchParams in one go to avoid multiple re-renders or API calls
        setSearchParams(newParams);
        dispatch(setDashboardSearchApplied());
    };

    return(
        <>
            <div className='bg-[#F9F3F5] pt-[95px] px-[30px] h-full w-full overflow-x-hidden'>
                <TopHeader title={"Dashboard"}/>
                <div className={`bg-white rounded-lg ${'py-3 h-customh3'}  relative`}>
                    <div className={`${'px-6'}`}>
                        <ManageDashboardTopBar
                            title={`List of Alerts`}
                            AddButton={false}
                            SearchInput={((data?.data?.length===0 &&searchParams.get("search_value")===null) ||data===undefined) ? false : true}
                            SearchPlaceholder={'Search for ID,Patient Name, Alert Type'}
                            menuBar={false}
                            suggestions={suggestions}
                            setSuggestions={setSuggestions}
                            optimizedFn={optimizedFn}
                            data={data}
                            filterValues={filterValues}
                            setFilterValues={setFilterValues}
                            handleApplyFilter={handleApplyFilter}
                            totalPageNumber={Math.ceil(parseInt(data?.total_count) / parseInt(limit))}
                            handleCheckBox={handleCheckBox}
                            ApplyFilter={(data===undefined||(data?.total_count===0&&searchParams?.get('search_value')!==null))?false:true}
                            initialState={initialState}
                            handleClearFilter={handleClearFilter}
                            dateFilter={dateFilter}
                            setdateFilter={setdateFilter}

                        /> 
                    </div>
                    {((isFetching&&status!=="fulfilled"&&status!=="rejected"&&!isSortselected)||(isLoading)||(data===undefined&&status!=="fulfilled"&&status!=="rejected"))  ? <CustomOverLay Active text="Loading Alert list..." classKey={`absolute top-0 left-0 right-0  z-50 overflow-hidden bg-gray-400 opacity-75 flex flex-col items-center justify-center  ${isSideBar ? ('opened_sidebar_overlay') : 'overlay-list'}`} /> :(data !== undefined && data?.data?.length > 0)  ? <>
                        <div className={`${'px-6'}`}>
                            <ManageDashboardTable
                                pageNumber={Number(searchParams.get('page_number')) || 1}
                                List={data}
                                handleSearchParams={handleSearchParams}
                                sortValue={searchParams.get('sort') || ''}
                                setisSortSelected={setisSortSelected}
                                setSelectedRow={setSelectedRow}
                                loading={loading}
                            />
                        </div>
                        {data?.total_count >= 15 && <div className="w-full px-2.5 py-1 flex items-center justify-between bg-[#F4F7FC] rounded-b-lg">
                            <p className="text-sm font-semibold text-[#687182]">Total Number of Records:{Math.ceil(parseInt(data?.total_count))}</p>
                            <div className="flex items-center">
                                <Limit
                                    limit={limit}
                                    setLimit={setLimit}
                                    handleNoOfRowsClick={handleNoOfRowsClick}
                                    isColumnSelect={isColumnSelect}
                                />

                                <Pagination
                                    TotalCount={parseInt(data?.total_count)}
                                    totalPageNumber={Math.ceil(parseInt(data?.total_count) / parseInt(searchParams?.get("limit")))}
                                    handleOnClickPageNumber={handleOnClickPageNumber}
                                    limit={parseInt(limit)}
                                />
                            </div>
                        </div>}
                    </> : <>
                        {/* empty screen */}
                        {(data?.total_count===0 &&suggestions?.trim()!=="")||(data?.success_status==="false")  ?
                            <SearchEmptyScreen text={"No exact matches found. Please try a different search"}  />
                            :
                            ((searchParams.get("alert_type")!==null||searchParams.get("reading_type")!==null||searchParams.get("start_date")!==null||searchParams.get("end_date")!==null)&&data?.total_count===0&&searchParams?.get("search_value")===null)?<SearchEmptyScreen
                                text={"That filter combination has no result. Please try different criteria"} setSkip={setSkip} />
                               
                                :(data?.total_count===0 && !searchParams.get("search_value")&&(!searchParams.get("filter")))?<Emptyscreen   title={"List of Alerts"} FirstPTag={"No Alerts received yet."}/>:
                                    ((status==="rejected"||(data?.total_count!==0&&data?.data?.length===0))&&<SearchEmptyScreen text={"No data found"}  />)
                        }
                    </>}
                </div>
            </div>
            {isAdvancedSearchOpen &&searchParams?.get('limit')&&!searchParams?.get('target_user_name') &&
                <DashboardAdvancedSearchbar 
                    handleOnSubmit={handleOnSubmit}
                />
            }
        </>
    )
}